import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Form as FormikForm, InputField, SelectField } from "components/common_components/Formik";
import * as Yup from "yup";
import Grid from "@material-ui/core/Grid";
import paymentMethods from "utils/static/paymentMethods";
import useDetailHandlers from "./useDetailHandlers";
import Button from "components/common_components/Button";
import { useSelector } from "react-redux";

function DetailForm({ posEntryMasterId, detailData, resources, onCancel, onDetailSuccess, isUserCreating, setSelectedDetail }) {
    const { categories } = resources;
    const { user } = useSelector((state) => state.Login);
    const { onSaveHandler } = useDetailHandlers({ onDetailSuccess, setSelectedDetail });

    const values = useMemo(() => {
        const { id, amount, categoryId, paymentMethod } = detailData;
        return {
            posEntryMasterId,
            id,
            amount,
            categoryId,
            paymentMethod,
            // notes: notes || "",
        };
    }, [posEntryMasterId, detailData]);

    const validationSchema = Yup.object({
        amount: Yup.number().min(1, "A valid amount is required").required("Required field"),
        categoryId: Yup.number()
            .required("Required field")
            .oneOf(
                categories.map((x) => x.id),
                "Not a valid category."
            ),
        paymentMethod: Yup.string()
            .required("Required field")
            .oneOf(
                paymentMethods.map((x) => x.value),
                "Not a valid payment method."
            ),
    });
    return (
        <div className="layout">
            <FormikForm
                validateOnChange={false}
                initialValues={values}
                validationSchema={validationSchema}
                onSubmit={onSaveHandler}
                onCancel={onCancel}
                showButtons={false}
                enableReinitialize
            >
                {(form) => (
                    <Grid container direction="column" spacing={2}>
                        <Grid item>
                            <InputField fieldName="amount" label="Amount *" currency placeholder="0" />
                        </Grid>
                        <Grid item>
                            <SelectField fieldName="categoryId" label="Category *" options={categories} valueKey="id" labelKey="name" />
                        </Grid>
                        <Grid item>
                            <SelectField fieldName="paymentMethod" label="Payment Method *" options={paymentMethods} />
                        </Grid>
                        {/* <Grid item>
                            <TextField fieldName="notes" label="Notes" multiline minRows={3} />
                        </Grid> */}
                        <Grid item>
                            <Grid container direction="row-reverse" spacing={2}>
                                <Grid item>
                                    {user.isAdmin ? (
                                        <Button secondary type="submit" loading={form.isSubmitting}>
                                            {form.values.id ? "Update" : "Add"}
                                        </Button>
                                    ) : (
                                        <>
                                            {isUserCreating && (
                                                <Button secondary type="submit" loading={form.isSubmitting}>
                                                    {form.values.id ? "Update" : "Add"}
                                                </Button>
                                            )}
                                            {!isUserCreating && !form.values.id && (
                                                <Button secondary type="submit" loading={form.isSubmitting}>
                                                    Add
                                                </Button>
                                            )}
                                        </>
                                    )}
                                </Grid>
                                <Grid item>
                                    <Button
                                        secondary
                                        outline
                                        onClick={() => {
                                            form.resetForm();
                                            onCancel();
                                        }}
                                    >
                                        Reset
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </FormikForm>
        </div>
    );
}

DetailForm.propTypes = {
    detailData: PropTypes.shape({
        posEntryMasterId: PropTypes.number,
        id: PropTypes.number,
        amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        categoryId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        paymentMethod: PropTypes.string,
        // notes: PropTypes.string,
    }),
    resources: PropTypes.shape({
        categories: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                code: PropTypes.string,
                name: PropTypes.string,
            })
        ),
    }),
    onCancel: PropTypes.func,
    onDetailSuccess: PropTypes.func,
    isUserCreating: PropTypes.bool,
    setSelectedDetail: PropTypes.func,
};

DetailForm.defaultProps = {
    detailData: {
        posEntryMasterId: undefined,
        id: undefined,
        amount: "",
        categoryId: "",
        paymentMethod: "",
        // notes: "",
    },
    resources: {
        categories: [],
    },
    onCancel: () => {},
    onDetailSuccess: (newId, payload) => true,
    isUserCreating: false,
    setSelectedDetail: (selectedDetail) => true,
};

export default DetailForm;
